import { BlobServiceClient } from "@azure/storage-blob";
// Admin files
const containerName = process.env.REACT_APP_STORAGE_CONTAINER;
const sasToken = process.env.REACT_APP_STORAGESASTOKEN;
const storageAccountName = process.env.REACT_APP_STORAGERESOURCENAME;
const blobService = new BlobServiceClient(
  `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
);
const containerClient = blobService.getContainerClient(containerName);

// Heashots
const containerNameHs = process.env.REACT_APP_HEADSHOTS_STORAGE_CONTAINER;
const sasTokenHs = process.env.REACT_APP_HEADSHOTS_STORAGESASTOKEN;
const storageAccountNameHs =
  process.env.REACT_APP_HEADSHOTS_STORAGERESOURCENAME;
const blobServiceHs = new BlobServiceClient(
  `https://${storageAccountNameHs}.blob.core.windows.net/?${sasTokenHs}`
);
const containerClientHs = blobServiceHs.getContainerClient(containerNameHs);

// Content images
const containerNameCi = process.env.REACT_APP_CONTENTIMAGES_STORAGE_CONTAINER;
const sasTokenCi = process.env.REACT_APP_CONTENTIMAGES_STORAGESASTOKEN;
const storageAccountNameCi =
  process.env.REACT_APP_CONTENTIMAGES_STORAGERESOURCENAME;

const blobServiceCi = new BlobServiceClient(
  `https://${storageAccountNameCi}.blob.core.windows.net/?${sasTokenCi}`
);
const containerClientCi = blobServiceCi.getContainerClient(containerNameCi);
export const isStorageConfigured = () => {
  return !storageAccountName || !sasToken ? false : true;
};
export const getBlobsInContainer = async () => {
  const returnedBlobUrls = [];

  // get list of blobs in container
  // eslint-disable-next-line
  for await (const blob of containerClient.listBlobsFlat()) {
    // if image is public, just construct URL
    console.log("blob", blob);
    returnedBlobUrls.push({
      blobName: blob.name,
      blobUrl: `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`,
    });
  }

  return returnedBlobUrls;
};

export const createBlobInContainer = async (file, filename = null) => {
  const fileName = filename === null ? file.name : filename;
  console.log("createBlobInContainer file", file);
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(fileName);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadData(file, options);
};

export const deleteBlobIfItExists = async (blobName) => {
  // include: Delete the base blob and all of its snapshots.
  // only: Delete only the blob's snapshots and not the blob itself.
  const options = {
    deleteSnapshots: "include", // or 'only'
  };

  // Create blob client from container client
  const blockBlobClient = await containerClient.getBlockBlobClient(blobName);

  await blockBlobClient.deleteIfExists(options);

  console.log(`deleted blob ${blobName}`);
};

export const createHeadshotInContainer = async (file, filename) => {
  console.log("createHeadshotInContainer file", file, filename);
  // create blobClient for container
  const blobClientHs = containerClientHs.getBlockBlobClient(filename);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClientHs.uploadData(file, options);
};


export const createContentImageInContainer = async (file, filename) => {
  console.log("createContentImageInContainer file", file, filename);
  // create blobClient for container
  const blobClientHs = containerClientCi.getBlockBlobClient(filename);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClientHs.uploadData(file, options);
};